import { useMutation, useQueryClient } from "react-query";
import { deactivateOfcVendorSvcByRecordId } from "../../../../actions/CarrierAgreementMgmt/OfficeVendorService";
import { toast } from "../../../../components/toastNotification";

// export const useDeactivateOfcVendorSvc = () => {
//   // const queryClient = useQueryClient();
//   // const { mutate } = useMutation(
//   //   (ids: number[] | undefined) => deactivateOfcVendorSvcByRecordId(ids),
//   //   {
//   //     onSuccess: () => {
//   //       queryClient.invalidateQueries(["GetBusLicensePermit"]);
//   //       toast.fire(
//   //         "Success",
//   //         "Office Vendor Services were deactivated successfully",
//   //         "success"
//   //       );
//   //     },
//   //     onError: () => {
//   //       toast.fire(
//   //         "Bulk deactivation of Office Vendor Services failed",
//   //         "Server Error: Cannot deactivate Office Vendor Services",
//   //         "error"
//   //       );
//   //     },
//   //   }
//   // );
//   // return mutate;
// };

const useDeactivateOfcVendorSvc = () => {
  return useMutation(deactivateOfcVendorSvcByRecordId);
};
export default useDeactivateOfcVendorSvc;
